<div class="flex align-items-center flex-row-reverse flex-wrap gap-2">
  <app-active-user-avatar
    styleClass="m-2"
    size="large"></app-active-user-avatar>
  <p-button
    type="button"
    icon="fas fa-ellipsis-v"
    [rounded]="true"
    (click)="menu.toggle($event)"></p-button>
  <app-notification-button />
  @if (userStore.canAccessUserManagement()) {
    <p-button
      tooltipPosition="left"
      pTooltip="Nutzer:innen verwalten"
      [rounded]="true"
      icon="fas fa-users"
      [routerLink]="[
        '/data-backend',
        { outlets: { overlay: 'nutzerverwaltung' } },
      ]"></p-button>
  }

  <app-theme-switcher></app-theme-switcher>
  <app-global-search></app-global-search>

  @if (userStore.canAccessEntityAdder()) {
    <p-button
      tooltipPosition="left"
      pTooltip="neu anlegen"
      [rounded]="true"
      icon="fas fa-plus-circle"
      [raised]="true"
      [routerLink]="[
        '/data-backend',
        { outlets: { overlay: 'neu' } },
      ]"></p-button>
  }

  <h1 class="pl-3">Datenpflege · {{ globalsStore.activeCommune()?.name }}</h1>
</div>
<p-menu
  #menu
  styleClass="right-0 left-auto w-20rem"
  [model]="items"
  [popup]="true">
  <ng-template pTemplate="item" let-item>
    @if (item.url) {
      <a class="p-menuitem-link" target="_blank" [href]="item.url">
        <div class="flex align-items-baseline">
          <i class="p-menuitem-icon" [class]="item.icon"></i>
          <div>
            <span>{{ item.label }}</span>
            @if (item.sub) {
              <div class="text-xs text-color-secondary mt-2">
                {{ item.sub }}
              </div>
            }
          </div>
        </div>
      </a>
    } @else {
      <a
        class="p-menuitem-link"
        [routerLink]="item.routerLink"
        [target]="item.target || '_self'">
        <div class="flex align-items-center">
          <i class="p-menuitem-icon" [class]="item.icon"></i>
          <div>
            <span>{{ item.label }}</span>
            @if (item.sub) {
              <div class="text-xs text-color-secondary mt-2">
                {{ item.sub }}
              </div>
            }
          </div>
        </div>
      </a>
    }
  </ng-template>
</p-menu>
